export default {
  base_url: "http://localhost:5000/",
  api_base_url: "https://newscrossword.ai/member-area",
  api_path: "https://newscrossword.ai/member-area/api/",
  temp_path:"http://34.56.214.170/member-area/api/"
};
